import { REPORT, REPORT_LIST, REPORT_MAP } from "@/constants/report";
import { Button, Form, Input, Radio } from "antd";
import { useCallback, useRef, useState } from "react";
import { When } from "react-if";
import HBModel from "../HBModal";
import ModalWrap from "../HBModal/ModalWrap";
import styles from "./index.module.less";

function ReportModal({
  onOk,
  onCancel,
  reportType,
  reportUserId,
  reportPinId,
  reportContentId,
  reportDomainId,
  reportFileId,
  reportBoardId,
  contentType,
  searchWord,
  pin,
  ...props
}) {
  const [reason, setReason] = useState(null);
  const [detail, setDetail] = useState("");
  const formRef = useRef(null);
  const onSubmit = useCallback(async () => {
    const values = await formRef.current.validateFields();
    onOk && onOk(values);
  }, [onOk]);

  const onChangeReason = useCallback((evt) => {
    setReason(evt.target.value);
  }, []);

  const onChangeDetail = useCallback((evt) => {
    setDetail(evt.target.value);
  }, []);

  return (
    <HBModel
      {...props}
      className={styles.modal}
      title="举报"
      width={550}
      onCancel={onCancel}
      footer={null}
    >
      <Form className={styles.form} ref={formRef} initialValues={{ reason: 0 }}>
        <Form.Item name="reason">
          <Radio.Group
            className={styles.radio}
            options={REPORT_LIST}
            onChange={onChangeReason}
          />
        </Form.Item>
        <When condition={reason === REPORT.OTHER}>
          <Form.Item name="detail">
            <Input
              className={styles.input}
              placeholder="请描述具体原因"
              onChange={onChangeDetail}
            />
          </Form.Item>
        </When>
      </Form>
      <div className={styles.desc}>
        图片存在侵权/知识产权问题？请按照
        <a
          href="//support.qq.com/products/30852/faqs-more/?id=108926 "
          target="_blank"
          rel="noreferrer"
        >
          该页面的相关说明
        </a>
        进行举报/维权
      </div>
      <div className={styles.footer} data-content-type={contentType}>
        <Button
          className={styles.button}
          onClick={onCancel}
          data-gd-click="button_click"
          data-button-name="取消举报"
          data-report-type={reportType}
          data-report-reason={
            reason === REPORT.OTHER
              ? `${REPORT_MAP[reason]}_${detail}`
              : REPORT_MAP[reason]
          }
          data-report-user-id={reportUserId}
          data-report-pin-id={reportPinId}
          data-report-content-id={reportContentId}
          data-report-domain-id={reportDomainId}
          data-report-file-id={reportFileId}
          data-board-id={reportBoardId}
          data-file-id={reportFileId}
          data-content-id={reportPinId}
          data-material-id={reportContentId}
          data-location="1"
        >
          取消
        </Button>
        <Button
          className={styles.button}
          type="primary"
          onClick={onSubmit}
          data-gd-click="button_click"
          data-button-name="提交举报"
          data-report-type={reportType}
          data-report-reason={
            (reason === REPORT.OTHER
              ? `${REPORT_MAP[reason]}_${detail}`
              : REPORT_MAP[reason]) || "垃圾广告"
          }
          data-report-user-id={reportUserId}
          data-report-pin-id={reportPinId}
          data-report-content-id={reportContentId}
          data-report-domain-id={reportDomainId}
          data-report-file-id={reportFileId}
          data-board-id={reportBoardId}
          data-file-id={reportFileId}
          data-content-id={reportPinId}
          data-material-id={reportContentId}
          data-search-word={searchWord}
          data-ext={JSON.stringify(pin?.ext)}
          data-location="2"
        >
          确定
        </Button>
      </div>
    </HBModel>
  );
}

export default ModalWrap(ReportModal);
